import { combineReducers } from "redux";
import authReducer from "./Signin";
import DashboardReducer from "./DashboardReducer";
import ProfileReducer from "./ProfileReducer";
import merchandiseCategoryReducer from "./MerchandiseCategoryReducer";
import questionnaireReducer from "./QuestionnaireReducer";

export default combineReducers({
  auth: authReducer,
  dashboard: DashboardReducer,
  adminProfile: ProfileReducer,
  merchandiseCategories: merchandiseCategoryReducer,
  questionnaire: questionnaireReducer,
});
